export default {
    contentFilter: {
        title: '版本内容过滤',
        description:
            '维护一份全局内容白名单，按 APP 构建号（builder）开关控制是否生效；生效构建只展示白名单内的内容（推荐、短剧、搜索、Banner 接口）。',
        versions: {
            title: '构建过滤开关',
            platform: {
                ios: 'iOS',
                android: 'Android',
            },
            count: '{total} 个构建 · 生效 {enabled} · 停用 {disabled}',
            add: '新增构建',
            enabled: '生效',
            disabled: '已停用',
            empty: '暂无构建',
        },
        modal: {
            createTitle: '新增构建',
            platform: '平台',
            versionName: 'Builder 号',
            versionPlaceholder: '请输入 Builder 号（纯数字）',
            builderPattern: 'Builder 号为 1~10 位纯数字',
            hint: '白名单默认开启，新构建将只展示白名单内的短剧',
            submit: '提交',
        },
        drama: {
            title: '短剧 ID 白名单',
            bannerBadge: 'Banner {count}/5',
            totalBadge: '共 {count} 个',
            addSearchPlaceholder: '输入名称或 ID 搜索短剧，从结果中选择',
            add: '添加',
            searchPlaceholder: '按 ID 或名称搜索',
            bannerHint: '★ 标记的短剧作为 App 推荐页 Banner 展示，最多 5 个；仅在白名单生效的构建可见',
            empty: '暂无短剧白名单',
            setBanner: '设为 Banner',
            removeBanner: '取消 Banner',
        },
        emptyWarning: '当前 {count} 个生效构建将看不到任何短剧',        removeConfirm: {
            title: '移出白名单',
            impact: '当前 {count} 个生效构建将立即不再展示',
            bannerAlso: '该短剧的 Banner 标记将一并移除',
            confirm: '移出',
        },
        message: {
            loadFailed: '加载失败',
            saveFailed: '保存失败',
            removeSuccess: '移出成功',
            versionCreated: '构建已添加',
            versionRemoved: '构建已删除',
            noIdsWarning: '请先从搜索结果中选择短剧',
            createSuccess: '已添加 {count} 条',
            invalidSkipped: '以下 ID 不存在，已跳过：{ids}',
        },
    },
};
